import React, { useEffect, useState } from "react";
import ProductSection from "../../common/ProductSection";
import axios from "axios";
import ProductSkeleton from "../../common/ProductSkeleton";
import { useTranslation } from "react-i18next";

const AllCategorySections = () => {
  const [categories, setCategories] = useState([]);
  const [productsByCategory, setProductsByCategory] = useState({});
  const [loading, setLoading] = useState(true);
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language || "en";

  // Helper function to get localized text
  const getLocalizedText = (item, field) => {
    if (!item || !item[field]) return "";
    
    if (typeof item[field] === 'string') {
      return item[field];
    }
    
    if (typeof item[field] === 'object') {
      return item[field][currentLanguage] || 
             item[field].en || 
             item[field].hi || 
             item[field].es || 
             item[field].zh || 
             "";
    }
    
    return "";
  };

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        setLoading(true);

        // Get all categories
        const catRes = await axios.get(
          `${process.env.REACT_APP_API_URL}/categories/get-all-categories`
        );
        const catData = catRes.data || [];

        // Fetch products for each category
        const productsPromises = catData.map((cat) =>
          axios
            .get(
              `${process.env.REACT_APP_API_URL}/products/sub-categories-products-by-category/${cat._id}`
            )
            .then((res) => ({
              categoryId: cat._id,
              data: res.data?.data || [],
            }))
            .catch(() => ({
              categoryId: cat._id,
              data: [],
            }))
        );

        const allProducts = await Promise.all(productsPromises);

        // Organize data category-wise
        const productMap = {};
        allProducts.forEach(({ categoryId, data }) => {
          const formattedProducts = [];
          
          data.forEach((subcatData) => {
            if (Array.isArray(subcatData.products)) {
              subcatData.products.forEach((product) => {
                const categoryName = getLocalizedText(subcatData.subCategory, "name") || 
                                    getLocalizedText(product.category, "name") || 
                                    t("product");
                
                formattedProducts.push({
                  _id: product._id,
                  id: product._id,
                  name: product?.name, // Keep multilingual object
                  category: categoryName, // Localized string
                  originalPrice: product.previous_price ? `₹${product.previous_price}` : null,
                  salePrice: `₹${product.price}`,
                  price: product.price,
                  previous_price: product.previous_price,
                  images: product.images,
                  image: product.images && product.images.length > 0
                    ? product.images[0]
                    : "https://via.placeholder.com/300x300?text=No+Image",
                  badge: product.isBestProduct ? "BEST" : null,
                  ratings: product.ratings,
                  description: product.description,
                  sku: product.sku,
                  isBestProduct: product.isBestProduct,
                  createdAt: product.createdAt,
                });
              });
            }
          });
          
          productMap[categoryId] = formattedProducts;
        });

        setCategories(catData);
        setProductsByCategory(productMap);
      } catch (error) {
        console.error("Error fetching categories/products:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, [t]);

  // Re-fetch when language changes
  useEffect(() => {
    if (categories.length > 0) {
      // Update categories with current language
      setCategories(prev => [...prev]);
      
      // Update product map with current language
      const updatedProductMap = { ...productsByCategory };
      Object.keys(updatedProductMap).forEach(categoryId => {
        updatedProductMap[categoryId] = updatedProductMap[categoryId].map(product => ({
          ...product,
          // Update category names based on current language
          category: getLocalizedText(product.category, "name") || t("product")
        }));
      });
      setProductsByCategory(updatedProductMap);
    }
  }, [currentLanguage]);

  if (loading) {
    return (
      <>
        {[...Array(7)].map((_, index) => (
          <ProductSkeleton key={index} />
        ))}
      </>
    );
  }

  return (
    <div className="">
      {categories.map((cat) => {
        const categoryName = getLocalizedText(cat, "name");
        const categoryDescription = getLocalizedText(cat, "description");
        
        return (
          <ProductSection
            key={cat._id}
            title={`${t("shop_by")} ${categoryName}`}
            filters={[t("new_products"), t("best_sellers"), t("featured")]}
            banner={{
              title: categoryName,
              subtitle: categoryDescription?.slice(0, 60) || t("exclusive_handicrafts"),
              discount: "",
              image: cat.imgUrl,
            }}
            products={productsByCategory[cat._id] || []}
            categoryId={cat._id}
          />
        );
      })}
    </div>
  );
};

export default AllCategorySections;





// import React, { useEffect, useState } from "react";
// import ProductSection from "../../common/ProductSection";
// import axios from "axios";
// import ProductSkeleton from "../../common/ProductSkeleton";

// const AllCategorySections = () => {
//   const [categories, setCategories] = useState([]);
//   const [productsByCategory, setProductsByCategory] = useState({});
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const fetchAllData = async () => {
//       try {
//         setLoading(true);

//         // Get all categories
//         const catRes = await axios.get(
//           `${process.env.REACT_APP_API_URL}/categories/get-all-categories`
//         );
//         const catData = catRes.data || [];

//         // Fetch products for each category
//         const productsPromises = catData.map((cat) =>
//           axios
//             .get(
//               `${process.env.REACT_APP_API_URL}/products/sub-categories-products-by-category/${cat._id}`
//             )
//             .then((res) => ({
//               categoryId: cat._id,
//               products: res.data?.data || [],
//             }))
//         );

//         const allProducts = await Promise.all(productsPromises);

//         // Organize data category-wise
//         const productMap = {};
//         allProducts.forEach(({ categoryId, products }) => {
//           const formattedProducts = [];
//           products.forEach((subcat) => {
//             if (Array.isArray(subcat.products)) {
//               subcat.products.forEach((p) => {
//                 formattedProducts.push({
//                   id: p._id,
//                   name: p.name,
//                   category: subcat.subCategory?.name || "Product",
//                   originalPrice: p.previous_price ? `₹${p.previous_price}` : null,
//                   salePrice: `₹${p.price}`,
//                   image:
//                     p.images && p.images.length > 0
//                       ? p.images[0]
//                       : "https://via.placeholder.com/300x300?text=No+Image",
//                   badge: p.isBestProduct ? "BEST" : null,
//                   ratings: p.ratings,
//                   description: p.description,
//                   sku: p.sku,
//                 });
//               });
//             }
//           });
//           productMap[categoryId] = formattedProducts;
//         });

//         setCategories(catData);
//         setProductsByCategory(productMap);
//       } catch (error) {
//         console.error("Error fetching categories/products:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAllData();
//   }, []);

//   if (loading) {
//     return (
//       <>
//         {[...Array(7)].map((_, index) => (
//           <ProductSkeleton key={index} />
//         ))}
//       </>
//     );
//   }


//   return (
//     <div className="">
//       {categories.map((cat) => (
//         <ProductSection
//           key={cat._id}
//           title={`Shop By ${cat.name}`}
//           filters={["New Products", "Best Sellers", "Featured"]}
//           banner={{
//             title: cat.name,
//             subtitle: cat.description?.slice(0, 60) || "Exclusive Handicrafts",
//             discount: "40%",
//             image: cat.imgUrl,
//           }}
//           products={productsByCategory[cat._id] || []}
//           categoryId={cat._id} 
//         />

//       ))}
//     </div>
//   );
// };

// export default AllCategorySections;
